import { render } from "./byFast.vue?vue&type=template&id=5cce4be7"
import script from "./byFast.vue?vue&type=script&lang=js"
export * from "./byFast.vue?vue&type=script&lang=js"

import exportComponent from "E:\\work\\高大\\pda\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__